import { render } from "./SlimDiagnosis.vue?vue&type=template&id=4cc3a5c2"
import script from "./SlimDiagnosis.vue?vue&type=script&lang=js"
export * from "./SlimDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__